import {
  ASSIGN_WAVE_TO_CONTROL_RECORD,
  BOOK_SHIPPING_CONTROL_RECORD,
  CANCEL_BOOK_SHIPPING_CONTROL_RECORD,
  GET_ERROR_OMS_CONTROL_RECORDS,
  GET_OMS_CONTROL_RECORDS,
  HOLD_CONTROL_RECORD,
  PRINT_CONTROL_RECORD_ERROR_CLEAR,
  PRINT_CONTROL_RECORD,
  REALLOCATE_CONTROL_RECORD,
  SAVE_CONTROL_RECORDS,
  SET_OMS_CONTROL_RECORDS,
  PICKEDUP_CONTROL_RECORDS,
  SHIPPED_CONTROL_RECORDS,
  UPDATE_CONTROL_RECORD_SHIPPING_ITEM_LINE,
  UPDATE_CONTROL_RECORD_DELIVERY_ADDRESS,
  UPDATE_CONTROL_RECORDS,
} from '../constants/constant_oms';

export const updatePickControlRecord = (payload) => {
  return {
    type: '@oms/UPDATE_PICK_CONTROL_RECORD',
    payload,
  };
};

export const updatePackControlRecord = (payload) => {
  return {
    type: '@oms/UPDATE_PACK_CONTROL_RECORD',
    payload,
  };
};

export const showOmsBarcodeScanModal = (payload = true) => {
  return {
    type: '@oms/SHOW_BARCODE_SCAN_MODAL',
    payload,
  };
};

export const setOmsBarcodeScanDataError = (error) => {
  return {
    type: '@oms/SET_BARCODE_SCAN_DATA',
    error,
  };
};

export const setOmsBarcodeScanData = (payload) => {
  return {
    type: '@oms/SET_BARCODE_SCAN_DATA',
    payload,
  };
};

export const fetchOmsControlRecords = (data) => {
  return {
    type: GET_OMS_CONTROL_RECORDS,
    data,
  };
};

export const setOmsControlRecords = (data) => {
  return {
    type: SET_OMS_CONTROL_RECORDS,
    data,
  };
};

export const fetchErrorOmsControlRecords = (error) => {
  return {
    type: GET_ERROR_OMS_CONTROL_RECORDS,
    payload: error,
  };
}

export const setStickyState = (key, value) => {
  return {
    type: `@oms/STICK_STATE`,
    key,
    value,
  };
};

export const selectInitialLine = (data, forceSelect) => {
  return {
    type: `@oms/INITIAL_SELECT_LINE`,
    data,
    force_select: forceSelect,
  };
};

export const selectAllInitialLines = (data, is_checked, force_select) => {
  return {
    type: `@oms/INITIAL_SELECT_LINES`,
    data,
    is_checked,
    force_select,
  };
};

export const resetSelectedInitialLines = () => {
  return {
    type: `@oms/INITIAL_RESET_SELECT_LINES`,
  };
};

export const selectPickLine = (data) => {
  return {
    type: `@oms/PICK_SELECT_LINE`,
    data,
  };
};

export const updatePickSelectLine = (key, data) => {
  return {
    type: '@oms/PICK_UPDATE_SELECT_LINE',
    key,
    data,
  };
};

export const updatePickSelectLines = (payload) => {
  return {
    payload,
    type: '@oms/PICK_UPDATE_SELECT_LINES',
  };
};

export const selectAllPickLines = (data, is_checked) => {
  return {
    type: `@oms/PICK_SELECT_LINES`,
    data,
    is_checked,
  };
};

export const resetSelectedPickLines = () => {
  return {
    type: `@oms/PICK_RESET_SELECT_LINES`,
  };
};

export const groupPickLines = (data) => {
  return {
    type: `@oms/PICK_GROUP_LINES`,
    data,
  };
};

export const setPickForm = (data) => {
  return {
    type: `@oms/PICK_FORM`,
    data,
  };
};

export const selectPackShipLine = (data) => {
  return {
    type: `@oms/PACKSHIP_SELECT_LINE`,
    data,
  };
};

export const selectAllPackShipLines = (data, is_checked) => {
  return {
    type: `@oms/PACKSHIP_SELECT_LINES`,
    data,
    is_checked,
  };
};

export const setPackShipLine = (data) => {
  return {
    type: '@oms/PACKSHIP_SET_SELECT_LINE',
    data,
  };
};

export const updatePackShipSelectLine = (key, data) => {
  return {
    type: '@oms/PACKSHIP_UPDATE_SELECT_LINE',
    key,
    data,
  };
};

export const updatePackShipSelectLines = (payload) => {
  return {
    payload,
    type: '@oms/PACKSHIP_UPDATE_SELECT_LINES',
  };
};

export const updateSelectGroupDeliveryAddress = (type, key, data) => {
  return {
    type: `@oms/${type}_UPDATE_SELECT_GROUP_DELIVERY_ADDRESS`,
    payload: {
      key,
      data,
    },
  };
};

export const updateSelectGroupShippingDetails = (type, key, data) => {
  return {
    type: `@oms/${type}_UPDATE_SELECT_GROUP_SHIPPING_DETAILS`,
    payload: {
      key,
      data,
    },
  };
};

export const resetSelectedPackShipLines = () => {
  return {
    type: `@oms/PACKSHIP_RESET_SELECT_LINES`,
  };
};

export const groupPackShipLines = (data) => {
  return {
    type: `@oms/PACKSHIP_GROUP_LINES`,
    data,
  };
};

export const setPackShipForm = (data) => {
  return {
    type: `@oms/PACKSHIP_FORM`,
    data,
  };
};

export const assignWaveToControlRecord = (data) => {
  return {
    type: ASSIGN_WAVE_TO_CONTROL_RECORD,
    data,
  };
};

export const savePickedControlRecords = (data) => {
  return {
    type: SAVE_CONTROL_RECORDS,
    data,
    pick: true,
  };
};

export const savePackedControlRecords = (data) => {
  return {
    type: SAVE_CONTROL_RECORDS,
    data,
    pack: true,
  };
};

export const saveShippedControlRecords = (data) => {
  return {
    type: SHIPPED_CONTROL_RECORDS,
    data,
    ship: true,
  };
};

export const savePickedUpControlRecords = (data) => {
  return {
    type: PICKEDUP_CONTROL_RECORDS,
    data,
    ship: true,
    is_pickup_store: true,
  };
};

export const saveControlRecords = (data) => {
  return {
    type: SAVE_CONTROL_RECORDS,
    direct: true,
    data,
  }
}

export const setUnholdLoading = (data) => {
  return {
    type: '@oms/UNHOLD_ORDER_LOADING',
    data,
  };
};

export const setHoldLoading = (data) => {
  return {
    type: '@oms/HOLD_ORDER_LOADING',
    data,
  };
};

export const setShipOrdersLoading = () => {
  return {
    type: '@oms/SHIP_ORDERS_LOADING',
  };
};

export const setPickLoading = (data) => {
  return {
    type: '@oms/PICK_ORDER_LOADING',
    data,
  };
};

export const setPackLoading = (data) => {
  return {
    type: '@oms/PACK_ORDER_LOADING',
    data,
  };
};

export const setShipLoading = (data) => {
  return {
    type: '@oms/SHIP_ORDER_LOADING',
    data,
  };
};

export const setRejectLoading = (data) => {
  return {
    type: '@oms/REJECT_ORDER_LOADING',
    data,
  };
};

export const setAssignWaveLoading = () => {
  return {
    type: '@oms/ASSIGN_WAVE_LOADING',
  };
};

export const clearOmsLoading = () => {
  return {
    type: '@oms/CLEAR_OMS_LOADING',
  };
};


export const bookShipping = (data, location, subsidiary) => {
  return {
    type: BOOK_SHIPPING_CONTROL_RECORD,
    payload: {
      data,
      location,
      subsidiary,
    },
  };
};

export const cancelBookShipping = (data, location, subsidiary) => {
  return {
    type: CANCEL_BOOK_SHIPPING_CONTROL_RECORD,
    payload: {
      data,
      location,
      subsidiary,
    },
  };
};

export const reallocateControlRecords = (data, fromPage) => {
  return {
    type: REALLOCATE_CONTROL_RECORD,
    data,
    fromPage,
  };
};

export const holdControlRecords = (data, fromPage) => {
  return {
    type: HOLD_CONTROL_RECORD,
    data,
    fromPage,
  };
};

export const unholdControlRecords = (data, fromPage) => {
  return {
    type: HOLD_CONTROL_RECORD,
    data,
    unhold: true,
    fromPage,
  };
};

export const printControlRecords = (payload) => {
  return {
    payload,
    type: PRINT_CONTROL_RECORD,
  };
}

export const printControlRecordErrorClear = (deliveryType, types) => {
  return {
    type: PRINT_CONTROL_RECORD_ERROR_CLEAR,
    payload: {
      deliveryType,
      types,
    },
  };
}

export const updateControlRecordShippingItemLine = (id, data) => {
  return {
    type: UPDATE_CONTROL_RECORD_SHIPPING_ITEM_LINE,
    payload: {
      id,
      data,
    },
  };
}

export const updateControlRecordDeliveryAddress = (id, data) => {
  return {
    type: UPDATE_CONTROL_RECORD_DELIVERY_ADDRESS,
    payload: {
      id,
      data,
    },
  };
}

export const updateControlRecords = (payload) => {
  return {
    payload,
    type: UPDATE_CONTROL_RECORDS,
  };
}
